<template>
<input
  class="form-control"
  :value="formattedValue"
  @keydown.enter.prevent="update"
  @blur="update"
  onfocus="this.select()"
>
</template>
<script>
import accounting from 'accounting'

export default {
  props: {
    value: {type: String, required: true}
  },
  data () {
    return {
      error: false
    }
  },
  computed: {
    formattedValue () {
      return accounting.formatMoney(this.value.replace(',', '.'), '', 2, ' ', ',')
    }
  },
  methods: {
    update (event) {
      const newValue = accounting.formatMoney(event.target.value.replace(',', '.'), '', 2, ' ', '.')
      if (newValue !== this.value) {
        this.$emit('input', newValue)
      } else {
        event.target.value = this.formattedValue
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CurrencyInput.vue?2b33448e